import { Injectable } from '@angular/core';
import { FirestoreService, Params } from './firebase/firestore.service';
import { COLLECTION_NAMES } from '@libs/constants/collections.const';
import { PlansModel, PlansType } from '@libs/models/plans.models';

@Injectable({ providedIn: 'root' })
export class PlanService extends FirestoreService {
    constructor() {
        super();

        this.setCollectionRef(COLLECTION_NAMES.PLANS);
    }

    public async getPlans(uid: string): Promise<PlansModel[]> {
        const params: Params = {
            orders: [
                {
                    fieldPath: 'order',
                    direction: 'asc'
                }
            ]
        };

        const data: PlansModel[] = await this.load(params);
        data.forEach((plan) => {
            if (plan.order === 1 || plan.nameBr?.toLocaleLowerCase().includes(PlansType.FREE_BR) || plan.nameEn?.toLocaleLowerCase().includes(PlansType.FREE_EN)) plan.icon = 'be-compass-duotone';
            if (plan.order === 2 || plan.nameBr?.toLocaleLowerCase().includes(PlansType.TRAINING_BR) || plan.nameEn?.toLocaleLowerCase().includes(PlansType.TRAINING_EN)) plan.icon = 'be-school-duotone';
            if (plan.order === 3 || plan.nameBr?.toLocaleLowerCase().includes(PlansType.PLACEMENT_BR) || plan.nameEn?.toLocaleLowerCase().includes(PlansType.PLACEMENT_EN)) plan.icon = 'be-match-duotone';
        });

        return data;
    }
}
